import firebase from 'firebase'

// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyALv1hSIpaaooKDHPu1DcYN8NuCR0EqrAM",
    authDomain: "dreamkit-react.firebaseapp.com",
    databaseURL: "https://dreamkit-react.firebaseio.com",
    projectId: "dreamkit-react",
    storageBucket: "dreamkit-react.appspot.com",
    messagingSenderId: "377696698819",
    appId: "1:377696698819:web:6b8aad82df6be8ab827d76",
    measurementId: "G-FLCQCDCJRS"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

export default firebase;
